module.exports = __webpack_public_path__ + "img/vignettes-asso_0000_poesie-en-liberte.944e7d7b.jpg";